<template>
  <sub-page :title="title">
    <div class="resident-service-page">
      <div class="search-box">
        <svg viewBox="0 0 24 24" class="search-icon"><circle cx="11" cy="11" r="7" fill="none" stroke="#969799" stroke-width="2"/><path d="M16 16 L21 21" stroke="#969799" stroke-width="2" stroke-linecap="round"/></svg>
        <input type="text" placeholder="请输入关键词" class="search-input" />
        <button class="search-btn">搜索</button>
      </div>
      <div class="hot-service">
        <div class="section-title">热门服务</div>
        <div class="hot-grid">
          <div class="hot-item" v-for="(item, idx) in hotServices" :key="idx">
            <img :src="item.icon" class="hot-icon" :alt="item.text" />
            <span class="hot-text">{{ item.text }}</span>
          </div>
        </div>
      </div>
      <div class="banner">
        <img :src="bannerImg" class="banner-img" alt="banner" />
      </div>
      <div class="service-section">
        <div class="section-header">
          <div class="section-title">人社服务</div>
          <div class="more-btn">更多</div>
        </div>
        <div class="service-grid">
          <div class="service-item" v-for="(item, idx) in humanServices" :key="idx">
            <img :src="item.icon" class="service-icon" :alt="item.text" />
            <span class="service-text">{{ item.text }}</span>
          </div>
        </div>
      </div>
      <div class="scene-section">
        <div class="section-header">
          <div class="section-title">服务场景</div>
          <div class="more-btn">更多</div>
        </div>
        <div class="scene-grid">
          <div class="scene-item" v-for="(item, idx) in sceneServices" :key="idx">
            <img :src="item.icon" class="scene-icon" :alt="item.text" />
            <span class="scene-text">{{ item.text }}</span>
          </div>
        </div>
      </div>
      <div class="news-section">
        <div class="section-header">
          <div class="section-title">热点资讯</div>
          <div class="more-btn">更多</div>
        </div>
        <div class="news-list">
          <div class="news-item" v-for="(item, idx) in newsList" :key="idx">
            <div class="news-title">{{ item.title }}</div>
            <div class="news-date">{{ item.date }}</div>
          </div>
        </div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'ResidentService',
  components: { SubPage },
  data() {
    return {
      title: '江苏省社保卡居民服务一件事',
      bannerImg: require('@/assets/banners/3f14f58d-88d7-4511-98ea-d55f6a407031.png'),
      hotServices: [
        { icon: require('@/assets/icons/app-card.png'), text: '招聘会查询' },
        { icon: require('@/assets/icons/app-salary.png'), text: '找工作' },
        { icon: require('@/assets/icons/app-info.png'), text: '景区客流' },
        { icon: require('@/assets/icons/app-skill.png'), text: '汽车票' },
        { icon: require('@/assets/icons/app-record.png'), text: '演出预告' }
      ],
      humanServices: [
        { icon: require('@/assets/icons/app-card.png'), text: '招聘会查询' },
        { icon: require('@/assets/icons/app-salary.png'), text: '社会保险个人权益' },
        { icon: require('@/assets/icons/app-info.png'), text: '参保信息查询' },
        { icon: require('@/assets/icons/app-skill.png'), text: '社保卡信息查询' },
        { icon: require('@/assets/icons/app-record.png'), text: '技能人员职业资格证书' },
        { icon: require('@/assets/icons/app-card.png'), text: '待遇资格认证' },
        { icon: require('@/assets/icons/app-salary.png'), text: '找工作' },
        { icon: require('@/assets/icons/app-info.png'), text: '社会保障卡申领' }
      ],
      sceneServices: [
        { icon: require('@/assets/icons/app-card.png'), text: '江苏省社会保障卡' },
        { icon: require('@/assets/icons/app-salary.png'), text: '水韵江苏' },
        { icon: require('@/assets/icons/app-info.png'), text: '交通出行' },
        { icon: require('@/assets/icons/app-skill.png'), text: '就医购药' }
      ],
      newsList: [
        { title: '【无锡市】换卡不换号 待遇不断档——无锡社保卡同号换...', date: '2026-09-24' },
        { title: '【常州市】社保卡赋能惠农惠民 "一卡通"社区服务再扩容', date: '2026-09-01' },
        { title: '【南京市】燃情苏超赛场解锁社保卡新体验！"一卡通"成居...', date: '2026-09-01' },
        { title: '【盐城市】燃情苏超 一卡通惠民——盐城市开展社保卡"一...', date: '2026-06-04' }
      ]
    }
  }
}
</script>

<style scoped>
.resident-service-page {
  background: #F3F8FB;
  min-height: 100%;
  padding-bottom: calc(40 * var(--w));
}
.search-box {
  display: flex;
  align-items: center;
  background: #fff;
  margin: calc(24 * var(--w)) calc(32 * var(--w));
  padding: 0 calc(24 * var(--w));
  height: calc(72 * var(--w));
  border-radius: calc(36 * var(--w));
  gap: calc(16 * var(--w));
}
.search-icon {
  width: calc(32 * var(--w));
  height: calc(32 * var(--w));
  flex-shrink: 0;
}
.search-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: calc(28 * var(--w));
  color: #323233;
  background: transparent;
}
.search-btn {
  background: #2E8CF6;
  color: #fff;
  font-size: calc(26 * var(--w));
  border: none;
  border-radius: calc(32 * var(--w));
  padding: calc(8 * var(--w)) calc(32 * var(--w));
  cursor: pointer;
  white-space: nowrap;
}
.hot-service {
  background: #fff;
  margin: 0 calc(32 * var(--w));
  border-radius: calc(8 * var(--w));
  padding: calc(32 * var(--w));
}
.section-title {
  font-size: calc(40 * var(--w));
  font-weight: 500;
  color: #323233;
  margin-bottom: calc(32 * var(--w));
}
.hot-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: calc(16 * var(--w));
}
.hot-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: calc(8 * var(--w));
}
.hot-icon {
  width: calc(64 * var(--w));
  height: calc(64 * var(--w));
  object-fit: contain;
}
.hot-text {
  font-size: calc(22 * var(--w));
  color: #323233;
  text-align: center;
}
.banner {
  margin: calc(24 * var(--w)) calc(32 * var(--w));
}
.banner-img {
  width: 100%;
  border-radius: calc(8 * var(--w));
}
.service-section,
.scene-section,
.news-section {
  background: #fff;
  margin: calc(24 * var(--w)) calc(32 * var(--w)) 0;
  border-radius: calc(8 * var(--w));
  padding: calc(32 * var(--w));
}
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: calc(32 * var(--w));
}
.more-btn {
  font-size: calc(26 * var(--w));
  color: #969799;
  cursor: pointer;
}
.service-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: calc(24 * var(--w));
}
.service-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: calc(8 * var(--w));
}
.service-icon {
  width: calc(64 * var(--w));
  height: calc(64 * var(--w));
  object-fit: contain;
}
.service-text {
  font-size: calc(22 * var(--w));
  color: #323233;
  text-align: center;
}
.scene-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: calc(24 * var(--w));
}
.scene-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: calc(8 * var(--w));
}
.scene-icon {
  width: calc(120 * var(--w));
  height: calc(80 * var(--w));
  object-fit: contain;
  border-radius: calc(8 * var(--w));
}
.scene-text {
  font-size: calc(22 * var(--w));
  color: #323233;
  text-align: center;
}
.news-list {
  display: flex;
  flex-direction: column;
  gap: calc(24 * var(--w));
}
.news-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: calc(24 * var(--w));
  border-bottom: 1px solid #f0f0f0;
}
.news-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
.news-title {
  font-size: calc(28 * var(--w));
  color: #323233;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: calc(16 * var(--w));
}
.news-date {
  font-size: calc(24 * var(--w));
  color: #969799;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/ResidentService.vue